import { useGetConversationsQuery } from "@/api/open-chat";
import { OpenChatConversation } from "@/types/open-chat";
import { SidebarHistoryRow } from "./sidebarHistoryRow";

interface Props {
  conversationId: string;
}

const emptyList: OpenChatConversation[] = [];

export const SidebarHistory = ({ conversationId }: Props) => {
  const { data: conversations = emptyList } = useGetConversationsQuery();

  const sortedConversations = [...conversations].sort((a, b) => (a.created_at < b.created_at ? 1 : -1));

  return (
    <div className="flex flex-1 flex-col gap-2 overflow-y-auto p-4">
      {sortedConversations.map(row => (
        <SidebarHistoryRow key={row.id} conversation={row} selected={row.id === conversationId} />
      ))}
    </div>
  );
};
